import { render } from "./ContactsMap.vue?vue&type=template&id=398440c4&scoped=true"
import script from "./ContactsMap.vue?vue&type=script&lang=js"
export * from "./ContactsMap.vue?vue&type=script&lang=js"

import "./ContactsMap.vue?vue&type=style&index=0&id=398440c4&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398440c4"]])

export default __exports__